<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-breakpoint="960"
    app
    permanent
    width="260"
    v-bind="$attrs"
    v-model="drawer"
    :mini-variant.sync="mini"
    mini-variant-width="80"
  >
    <v-layout justify-space-between column fill-height>
    <!--
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>
    -->
    
    <v-list
      expand
      nav
    >
      <div />
      <v-container>
        <v-row>
          <v-col>
            <v-img
              class="my-2"
              :src="mini ? require('@/assets/fav.png') : require('@/assets/logo-white.png')"
              height="60px"
              contain
            />
          </v-col>
        </v-row>
      </v-container>
      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
          :class="mini ? 'center' : ''"
        />
      </template>
      <div />

    </v-list>

    <v-container justify-end>
      <v-row>
        <v-col class="pl-2">
      <v-list-item
        v-if="!companySubscription"
        :class="mini ? 'center' : ''"
        @click="dialogUpgradeAccount = true"
      >
        <v-list-item-icon>
          <v-icon v-text="premium.icon"></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t(premium.title) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
        </v-col></v-row>
      <v-row>
        <v-col class="text-right">
         <v-btn
          class="ma-3"
          elevation="1"
          fab
          small
          @click.stop="toggleMini"
        >
          <v-icon class="center">
            {{ mini ? 'mdi-chevron-right' : 'mdi-chevron-left' }}
          </v-icon>
        </v-btn>
        </v-col>
      </v-row>
    </v-container>
    </v-layout>
    <v-dialog
      v-model="dialogUpgradeAccount"
      max-width="800"
    >
    <v-card>
        <base-v-component
          v-if="!isPaymentLoading"
          class="pt-8"
          :heading="$t('upgrade-premium')"
          :subtitle="$t('upgrade-subtitle')"
        />
        <v-card-text>
      <UpgradeAccount v-on:paymentLoading="isPaymentLoading = true"/>
        </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            text
            @click="dialogUpgradeAccount = false"
          >
            {{ $t('close') }}
          </v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>
  </v-navigation-drawer>

</template>

<script>
  // Utilities
  import {
    mapState,
  } from 'vuex'

  import UpgradeAccount from '@/components/UpgradeAccount'

  export default {
    name: 'DashboardCoreDrawer',
    components: {
      UpgradeAccount
    },
    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      dialogUpgradeAccount: false,
      isPaymentLoading: false,
      items: [
        {
          icon: 'mdi-view-dashboard',
          title: 'dashboard',
          to: '/dashboard',
        },
        {
          title: 'products',
          icon: 'mdi-clipboard-outline',
          to: '/products',
        },
        {
          title: 'evaluations',
          icon: 'mdi-check-bold',
          to: '/evaluations',
        },
        {
          title: 'ingredients',
          icon: 'mdi-flask-outline',
          to: '/ingredients',
        },
        {
          title: 'templates',
          icon: 'mdi-file-document',
          to: '/templates',
        },
        {
          icon: 'mdi-account',
          title: 'account',
          to: '/account',
        },
      ],
      premium: {
        title: 'upgrade-premium',
        icon: 'mdi-diamond-stone',
        to: '/subscription',
      },
    }),
    computed: {
      ...mapState(['barColor', 'barImage']),
      drawer: {
        get () {
          return this.$store.getters['common/getDrawer']
        },
        set () {
          //this.$store.commit('SET_DRAWER', val)
        },
      },
      mini: {
        get () {
          return this.$store.getters['common/getMini']
        },
        set () {
          // none
        }
      },
      companySubscription() {
        return this.$store.getters['company/getSubscription']
      },
      computedItems () {
        return this.items.map(this.mapItem)
      },
      profile () {
        return {
          avatar: true,
          title: this.$t('avatar'),
        }
      },
    },

    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
      toggleMini () {
        this.$store.dispatch('common/toggleMini')
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
    .center
      .v-list-item__icon
        margin: auto !important
</style>
